import useSWR from "swr";
import fetcher from "./fetcher";

/*
 * Admin-only operational summary for one shop. Fetched on shop change rather
 * than on drawer open so the sidebar badge has something to show without an
 * interaction; the endpoint is a handful of indexed lookups, and SWR dedupes
 * across the trigger and the drawer.
 *
 * Deliberately without keepPreviousData: it returns the previous key's payload
 * while the new one is in flight, which on an identity-scoped panel means one
 * shop's payout totals and owner rendering under another shop's name — and with
 * data present, nothing reports as loading. Without it SWR reads only the
 * current key's cache entry, so a shop switch shows a skeleton until its own
 * data arrives.
 */
export default function useShopInfo(influencerId, enabled = true) {
  const { data, error, isLoading, mutate } = useSWR(
    enabled && influencerId ? `/api/influencer/${influencerId}/shopInfo` : null,
    fetcher,
  );

  return {
    shopInfo: data ?? null,
    error,
    isError: Boolean(error),
    isLoading,
    refresh: mutate,
  };
}
